/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A navigation solution for VDK Web. (@accedo/vdkweb-navigation) 5.0.7
* 
*******************************************************************************/"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.isValidFocusId=void 0;var isValidFocusId=function(a){return!!a&&"string"==typeof a};exports.isValidFocusId=isValidFocusId;